module.exports = __webpack_public_path__ + "static/img/error.1745385299907.jpg";